const BaseUrl =
"https://panel.whitelabelmd.com/primavida/api/";
// const BaseUrl=
// "https://lightgoldenrodyellow-okapi-586794.hostingersite.com/primavida/api/";

export const products_url = BaseUrl + "get_products";
export const cheke_state = BaseUrl + "cheke_state";
export const add_user_check_product = BaseUrl + "createOrder_test";
export const createOrder_test_new = BaseUrl + "createOrder_test";
export const contact_details_step_25 = BaseUrl + "contact_details_step_25";
export const get_checkout_link_data = BaseUrl + "get_checkout_link_data";
export const get_product_details = BaseUrl + "get_product_details";
export const get_product_details_v3 = BaseUrl + "get_product_details_v3";
export const get_url_data = BaseUrl + "get_url_data";
export const createOrder_test = BaseUrl + "createOrder_test";
const WlmdBackendUrl = "https://panel.whitelabelmd.com/wlmdbackend/api/";

export const SITE_ID = 371;
export const check_coupons = WlmdBackendUrl + "check_coupons_v3";
export const member_view = BaseUrl + "member_view";